import Image from 'next/image';
import wave from './wave.png';
import { AnimatedLink } from '@/components/AnimatedLink';

export interface TestimonialWaveCardProps {
  quote: string;
  title: string;
  position: string;
  name?: string;
  avatar?: {
    src: string;
    alt: string;
  };
  logo?: React.ReactNode;
  info?: {
    title?: string;
    text?: string;
  }[];
  link: {
    text: string;
    href: string;
  };
}

export default function TestimonialWaveCard({
  quote,
  title,
  position,
  name,
  avatar,
  logo,
  link,
}: TestimonialWaveCardProps) {
  return (
    <div className="relative grid w-full grid-cols-1 gap-6 overflow-hidden rounded-4xl p-6 md:grid-cols-2 md:flex-row md:p-10 lg:py-20">
      <Image
        src={wave.src}
        alt=""
        width={800}
        height={270}
        className="new-wave-animation z-1 absolute left-0 top-0 w-full rounded-4xl"
      />
      <div className="max-w-sm pt-4 lg:pt-0">
        {logo && <div className="mb-4 lg:mb-10">{logo}</div>}
        <p className="text-eyebrow-strong mb-4 lg:mb-10">{title}</p>
        <AnimatedLink href={link.href} hrefTarget="_blank" linkText={link.text} />
      </div>
      <div className="z-10 max-w-xl rounded-2xl bg-[#1F1F1F] p-4 lg:p-8">
        <blockquote className="">
          <svg
            width="53"
            height="39"
            viewBox="0 0 53 39"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mb-3"
          >
            <path
              opacity="0.1"
              d="M30.9542 0V16.0138C30.9542 28.3725 39.1935 36.7488 50.7917 39L52.989 34.3395C47.6183 32.3527 44.1667 26.4572 44.1667 21.6667H53V0H30.9542ZM0 0V16.0138C0 28.3725 8.27684 36.751 19.875 39L22.0745 34.3395C16.7016 32.3527 13.25 26.4572 13.25 21.6667H22.0458V0H0Z"
              fill="white"
            />
          </svg>

          <p className="text-body-quote mb-4 lg:mb-10">{quote}</p>
          <div className="flex items-center gap-4">
            {avatar && (
              <Image src={avatar.src} alt={avatar.alt} className="size-10 rounded-full" width={40} height={40} />
            )}
            <footer className="">
              {name}
              <br />
              {position}
            </footer>
          </div>
        </blockquote>
      </div>
    </div>
  );
}
